import React from "react";

interface Props {
  className?: string;
}

const InfoIcon = (props: Props) => {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="27"
      fill="none"
      viewBox="0 0 32 27"
    >
      <path
        stroke="#373737"
        strokeWidth="1.5"
        d="M1 2v21.855c0 .946 1.192 1.363 1.782.623l5.176-6.494a1 1 0 01.782-.377H30a1 1 0 001-1V2a1 1 0 00-1-1H2a1 1 0 00-1 1z"
      ></path>
      <path stroke="#373737" strokeLinecap="round" strokeWidth="2" d="M16 9v4"></path>
      <circle cx="16" cy="5.286" r="1.071" fill="#373737"></circle>
    </svg>
  );
};

export default InfoIcon;
